<template>
  <div>
    <b-row v-if="exportEnabled" class="float-right">
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="0" label class="mb-0">
          <b-input-group>
            <b-input-group-append>
              <b-button @click="exportToExcel" variant="primary">Exportar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      ref="table"
      show-empty
      :dark="dark"
      :busy="loading"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive
      :items.sync="items"
      :fields="captions"
      :current-page="currentPage"
    >
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="m-2 align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <div slot="paymentMethodFormatted" slot-scope="data" v-html="data.value"></div>
      <div slot="advanceOnReceivablesFormatted" slot-scope="data" v-html="data.value"></div>
      <span slot="transactionId" slot-scope="data">
        <small>{{data.value}}</small>
      </span>
      <span slot="cardNumber" slot-scope="data">
        <small>{{data.value}}</small>
      </span>
      <span slot="sellerName" slot-scope="data">
        <small>{{data.value}}</small>
      </span>
      <span slot="billetCode" slot-scope="data">
        <small>{{(data.value.length > 20 ? `${data.value.substring(0, 20)}...` : data.value)}}</small>
      </span>
      <template slot="type" slot-scope="data">{{bindTypeName(data.value)}}</template>
      <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
      <template slot="customerType" slot-scope="data">{{bindBusinessTypeName(data.value)}}</template>
      <template slot="scheduledDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="chargeDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="escrowDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="date" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="insertedAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="endedDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="createdAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="updatedAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="acquirerEscrowDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      <template slot="amount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="balance" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="grossAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="netAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="spreadAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="acquirerFeeAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="sellerNetAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="salespersonAmount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
      <template slot="automaticWithdrawal" slot-scope="data">{{data.value ? "Sim" : "Não"}}</template>
      <template slot="transactionActions" slot-scope="row">
        <b-link
          v-show="actionUri != ''"
          :to="`/${actionUri}/${row.item.id}`"
          class="btn mr-2 btn-md btn-primary action-btn"
        >
          <i class="fa fa-edit"></i>
        </b-link>
      </template>
      <template slot="detailedTransactionActions" slot-scope="row">
        <button @click.prevent="row.toggleDetails" class="btn mr-2 btn-md btn-secondary action-btn">
          <i class="fa fa-search-plus"></i>
        </button>
        <b-link
          v-show="actionUri != ''"
          :to="`/${actionUri}/${row.item.id}`"
          class="btn mr-2 btn-md btn-primary action-btn"
        >
          <i class="fa fa-edit"></i>
        </b-link>
      </template>
      <template slot="actions" slot-scope="row">
        <b-link
          v-show="actionUri != ''"
          :to="`/${actionUri}/edit/${row.item.id}`"
          class="btn mr-2 btn-md btn-primary action-btn"
        >
          <i class="fa fa-edit"></i>
        </b-link>
        <!--<button v-show="actionUri != ''" @click.prevent="onCustomActionClick('remove', row)" class="btn mr-2 btn-md btn-secondary action-btn">
          <i class="fa fa-trash-o"></i>
        </button>-->
        <button
          v-for="(a, index) in customActions"
          :key="index"
          v-html="a.html"
          :class="a.cssClass"
          @click.prevent="onCustomActionClick(a.action, row)"
        ></button>
      </template>
      <template slot="showDashboardDetail" slot-scope="row">
        <button @click.prevent="row.toggleDetails" class="btn mr-2 btn-md btn-secondary action-btn">
          <i class="fa fa-search-plus"></i>
        </button>
      </template>
      <template slot="shortUrl" slot-scope="row">
        <a target="_blank" :href="row.item.shortUrl">
          <strong>Ver link</strong>
        </a>
      </template>
      <template slot="roles" slot-scope="data">
        <span v-html="bindUserRoleName(data.value)"></span>
      </template>
      <template slot="deviceAuditingAddInfo" slot-scope="row">
        <span v-html="bindDeviceAuditingAddInfo(row.item)"></span>
      </template>
      <template slot="showDeviceAuditingDetail" slot-scope="row">
        <button
          @click.prevent="row.toggleDetails"
          class="btn mr-2 btn-md btn-secondary action-btn"
          v-if="row.item.oldValues != null"
        >
          <i class="fa fa-search-plus"></i>
        </button>
      </template>
      <template slot="row-details" slot-scope="row">
        <template v-if="tableName == 'auditTable'">
          <b-card>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Atributo</th>
                  <th scope="col">Valor antigo</th>
                  <th scope="col">Valor novo</th>
                </tr>
              </thead>
              <template v-if="row.item.tableName == 'Device'">
                <tbody v-html="auditingDeviceInfo(row.item)"></tbody>
              </template>
              <template v-else-if="row.item.tableName == 'DeviceContract'">
                <tbody v-html="auditingDeviceContractInfo(row.item)"></tbody>
              </template>
            </table>
          </b-card>
        </template>
        <template v-else>
          <b-card>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>                  
                  <th scope="col">Adquirente data receb.</th> 
                  <th scope="col">Valor adq.</th>                  
                  <th scope="col">Valor plat.</th>
                  <th scope="col">Imposto</th>
                  <th scope="col">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><small>{{row.item.code}}</small></td>
                  <td>{{formatDateTimeFields(row.item.acquirerEscrowDate)}}</td>
                  <td
                    scope="row"
                  >{{row.item.acquirerFee.toFixed(2).toLocaleString('pt-BR')}}% | {{formatDecimalFields(row.item.acquirerFeeAmount)}}</td>
                  <td>{{row.item.platformFee.toFixed(2).toLocaleString('pt-BR')}}% | {{formatDecimalFields(row.item.platformAmount)}}</td>
                  <td>{{row.item.partnerTax.toFixed(2).toLocaleString('pt-BR')}} | {{formatDecimalFields(row.item.partnerTaxAmount)}}</td>
                  <td>{{(row.item.acquirerFee + row.item.platformFee + row.item.partnerTax).toFixed(2).toLocaleString('pt-BR')}}% | {{formatDecimalFields((row.item.acquirerFeeAmount + row.item.platformAmount + row.item.partnerTaxAmount))}} </td>
                </tr>
              </tbody>
            </table>
            <b-button size="sm" @click="row.toggleDetails">Fechar</b-button>
          </b-card>
        </template>
      </template>
    </b-table>
    <nav>
      <b-pagination
        :total-rows="totalRows"
        :per-page.sync="tableData.pageSize"
        v-model="currentPage"
        prev-text="Voltar"
        next-text="Próximo"
        @change="pageIndexChanged"
        first-text="Primeiro"
        last-text="Último"
      />
    </nav>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: "c-table",
  inheritAttrs: false,
  props: {
    tableName: {
      type: String,
      default: "Table"
    },
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Object,
      default: () => {}
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    actionUri: {
      type: String,
      default: ""
    },
    customActions: {
      type: [Array, Object],
      default: () => []
    },
    exportEnabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1
    };
  },
  computed: {
    items: function() {
      return this.tableData.data;
    },
    totalRows: function() {
      return this.tableData.rowCount;
    },
    captions: function() {
      return this.fields;
    }
  },
  watch: {
    tableData: function(value) {
      this.currentPage = value.pageIndex;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    onCustomActionClick(action, row) {
      this.$emit("onCustomActionClick", action, row);
    },
    pageIndexChanged(page) {
      this.currentPage = page;
      this.$emit("onPageIndexChanged", page, this.tableName);
    },
    exportToExcel() {
      this.$emit("onExportToExcelClick", this.tableName);
    },
    bindUserRoleName(value) {
      switch (value)
      {
        case 'Partner':
          return 'Master'
        case 'Backoffice':
          return 'Backoffice';
        case 'Finance':
          return 'Financeiro';
        case 'Seller':
          return 'Empresa';
        case 'Logistic':
          return 'Logistica';
        case 'Salesman':
          return 'Representante';
      }
    },
    formatDateTimeFields(value) {
      return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
    },
    formatDecimalFields(value) {
      return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    bindBusinessTypeName(value) {
      switch(value.toUpperCase())
      {
        case 'SELLER':
          return 'Empresa';
        case 'SALESPERSON':
          return 'Representante';
        case 'Partner':
            'Administrador';
      }
    },
    bindTypeName(value) {
      switch(value.toUpperCase()) {
        case 'SEND':
          return 'Arquivo de remessa';
        case 'RETURN':
          return 'Arquivo de retorno';
        default:
          return value;
      }
    },
    bindStatusName(value) {
      switch(value.toUpperCase()) {
        case 'ACTIVE':
          return 'Ativo';
        case 'INACTIVE':
          return 'Inativo';
        case 'BLOCKED':
          return 'Bloqueado';
        case 'OPEN':
          return 'Livre';
        case 'ENABLED':
          return 'Ativado';
        case 'DISABLED':
          return 'Desativado';
        case 'ATTACHED':
          return 'Vinculado';
        case 'DANIFIED':
          return 'Danificado';
        case 'CREATED':
          return 'Criado';
        case 'PROCESSING':
          return 'Processando';
        case 'CANCELED':
          return 'Cancelado';
        case 'EXPIRED':
          return 'Expirado';
        case 'PAID':
          return 'Pago';
        case 'PENDING':
          return 'Pendente';
        case 'ANALYSIS':
          return 'Em análise';
        case 'DONE':
          return 'Finalizado';
        case 'WAITINGPAYMENT':
          return 'Aguard. Pagto';
        case 'INANALYSIS':
          return 'Análise'
        case 'PAYED':
          return 'Pago'
        case 'AVAILABLE':
          return 'Disponivel'
        case 'INDISPUTE':
          return 'Disputa'
        case 'RETURNED':
          return 'Devolvida'
        case 'CANCELLED':
          return 'Cancelado'
        case 'DEBITED':
          return 'Devolvida'
        case 'TEMPORARYRETENTION':
          return 'Retenção Temp.'
      }
    },
    auditingDeviceInfo(value) {
      const oldValues = value.oldValues ? JSON.parse(value.oldValues) : null;
      const newValues = value.newValues ? JSON.parse(value.newValues) : null;
      const addInfo = value.addInfo ? JSON.parse(value.addInfo) : {};
      let content = `<tr>
                  <td scope="row"><strong>Serial Number</strong></td>
                  <td scope="row">${
                    oldValues != null ? oldValues.SerialNumber : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? newValues.SerialNumber : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Logic Number</strong></td>
                  <td scope="row">${
                    oldValues != null ? oldValues.LogicNumber : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? newValues.LogicNumber : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Modelo</strong></td>
                  <td scope="row">${
                    oldValues != null ? oldValues.DeviceModel.Name : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? newValues.DeviceModel.Name : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Contrato</strong></td>
                  <td scope="row">${
                    oldValues != null
                      ? oldValues.DeviceContract
                        ? oldValues.DeviceContract.Name
                        : "Sem contrato associado"
                      : ""
                  }</td>
                  <td scope="row">${
                    newValues != null
                      ? newValues.DeviceContract != null
                        ? newValues.DeviceContract.Name
                        : "Sem contrato associado"
                      : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Empresa</strong></td>
                  <td scope="row">${
                    oldValues != null
                      ? oldValues.Seller
                        ? oldValues.Seller.Name
                        : "Sem empresa associada"
                      : ""
                  }</td>
                  <td scope="row">${
                    newValues != null
                      ? newValues.Seller
                        ? newValues.Seller.Name
                        : "Sem empresa associada"
                      : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Status</strong></td>
                  <td scope="row">${
                    addInfo.OldStatus ? addInfo.OldStatus : "-"
                  }</td>
                  <td scope="row">${
                    addInfo.NewStatus ? addInfo.NewStatus : "-"
                  }</td>
                </tr>`;
      return content;
    },    
    bindDeviceAuditingAddInfo(value) {
      if (value.addInfo == "") {
        return "";
      }
      const addInfo = JSON.parse(value.addInfo);
      return `<strong>Status Anterior:</strong> ${addInfo.OldStatus} | <strong>Atual:</strong> ${addInfo.NewStatus}`;
    },
    auditingDeviceContractInfo(value) {
      const oldValues = value.oldValues ? JSON.parse(value.oldValues) : null;
      const newValues = value.newValues ? JSON.parse(value.newValues) : null;
      const addInfo = value.addInfo ? JSON.parse(value.addInfo) : {};
      let formatter = new Intl.NumberFormat('pt-BR');
      let currencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
      let content = `<tr>
                  <td scope="row"><strong>Nome</strong></td>
                  <td scope="row">${
                    oldValues != null ? oldValues.Name : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? newValues.Name : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Descrição</strong></td>
                  <td scope="row">${
                    oldValues != null ? oldValues.Description : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? newValues.Description : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Custo perda POS</strong></td>
                  <td scope="row">${
                    oldValues != null ? currencyFormatter.format(oldValues.ReplacementDeviceValue) : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? currencyFormatter.format(newValues.ReplacementDeviceValue) : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Repase automático?</strong></td>
                  <td scope="row">${
                    oldValues != null ? (oldValues.AutomaticRepass ? 'Sim' : 'Não') : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? (newValues.AutomaticRepass ? 'Sim' : 'Não') : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Comissão representante sob valor da transação?</strong></td>
                  <td scope="row">${
                    oldValues != null ? (oldValues.IsSalesmanFeeOnGrossAmount ? 'Sim' : 'Não') : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? (newValues.IsSalesmanFeeOnGrossAmount ? 'Sim' : 'Não') : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Ativo?</strong></td>
                  <td scope="row">${
                    oldValues != null ? (oldValues.IsActive ? 'Sim' : 'Não') : ""
                  }</td>
                  <td scope="row">${
                    newValues != null ? (newValues.IsActive ? 'Sim' : 'Não') : ""
                  }</td>
                </tr>
                <tr>
                  <td scope="row"><strong>Aluguel Maquineta</strong></td>
                  <td scope="row">
                    ${
                      oldValues != null ? (oldValues.IsRental ? 'Sim' : 'Não') : ""
                    }
                    <br />
                    <strong>Aluguel</strong>: ${oldValues != null ? currencyFormatter.format(oldValues.RentalValue) : ""}
                    <br />
                    <strong>Aluguel Maq. Promocional</strong>: ${oldValues != null ? currencyFormatter.format(oldValues.PromotionalRentalValue) : ""}
                    <br />
                    <strong>Validade Promoção</strong>: ${oldValues != null && oldValues.PromotionalRentalValueDuration != null ? oldValues.PromotionalRentalValueDuration : ""}
                  </td>
                  <td scope="row">${
                      newValues != null ? (newValues.IsRental ? 'Sim' : 'Não') : ""
                    }
                    <br />
                    <strong>Aluguel</strong>: ${newValues != null ? currencyFormatter.format(newValues.RentalValue) : ""}
                    <br />
                    <strong>Aluguel Maq. Promocional</strong>: ${newValues != null ? currencyFormatter.format(newValues.PromotionalRentalValue) : ""}
                    <br />
                    <strong>Validade Promoção</strong>: ${newValues != null && newValues.PromotionalRentalValueDuration != null ? newValues.PromotionalRentalValueDuration : ""}
                  </td>
                </tr>
                <tr>
                  <td scope="row"><strong>Debito</strong></td>
                  <td scope="row">
                    <strong>Imposto %</strong>: ${oldValues != null ? formatter.format(oldValues.PartnerDebitTax) : ""}
                    <br />
                    <strong>Taxa %</strong>: ${oldValues != null ? formatter.format(oldValues.DebitPartnerFee) : ""}
                    <br />
                    <strong>Plataforma %</strong>: ${oldValues != null ? formatter.format(oldValues.DebitPlatformFee) : ""}
                    <br />
                    <strong>Comissão %</strong>: ${oldValues != null ? formatter.format(oldValues.DebitSalesmanFee) : ""}
                    <br />
                    <strong>Dias Disponivel</strong>: ${oldValues != null ? oldValues.DebitPayoutIntervalId : ""}
                  </td>
                  <td scope="row">
                    <strong>Imposto %</strong>: ${newValues != null ? formatter.format(newValues.PartnerDebitTax) : ""}
                    <br />
                    <strong>Taxa %</strong>: ${newValues != null ? formatter.format(newValues.DebitPartnerFee) : ""}
                    <br />
                    <strong>Plataforma %</strong>: ${newValues != null ? formatter.format(newValues.DebitPlatformFee) : ""}
                    <br />
                    <strong>Comissão %</strong>: ${newValues != null ? formatter.format(newValues.DebitSalesmanFee) : ""}
                    <br />
                    <strong>Dias Disponivel</strong>: ${newValues != null ? newValues.DebitPayoutIntervalId : ""}
                  </td>
                </tr>
                <tr>
                  <td scope="row"><strong>Credito</strong></td>
                  <td scope="row">
                    <strong>Imposto %</strong>: ${oldValues != null ? formatter.format(oldValues.PartnerCreditTax) : ""}
                    <br />
                    <strong>Taxa %</strong>: ${oldValues != null ? formatter.format(oldValues.CreditChipSinglePartnerFee) : ""}
                    <br />
                    <strong>Plataforma %</strong>: ${oldValues != null ? formatter.format(oldValues.CreditPlatformFee) : ""}
                    <br />
                    <strong>Comissão %</strong>: ${oldValues != null ? formatter.format(oldValues.CreditChipSingleSalesmanFee) : ""}
                    <br />
                    <strong>Dias Disponivel</strong>: ${oldValues != null ? oldValues.CreditChipSinglePayoutIntervalId : ""}
                  </td>
                  <td scope="row">
                    <strong>Imposto %</strong>: ${newValues != null ? formatter.format(newValues.PartnerCreditTax) : ""}
                    <br />
                    <strong>Taxa %</strong>: ${newValues != null ? formatter.format(newValues.CreditChipSinglePartnerFee) : ""}
                    <br />
                    <strong>Plataforma %</strong>: ${newValues != null ? formatter.format(newValues.CreditPlatformFee) : ""}
                    <br />
                    <strong>Comissão %</strong>: ${newValues != null ? formatter.format(newValues.CreditChipSingleSalesmanFee) : ""}
                    <br />
                    <strong>Dias Disponivel</strong>: ${newValues != null ? newValues.CreditChipSinglePayoutIntervalId : ""}
                  </td>
                </tr>
                <tr>
                  <td scope="row"><strong>Credito Parcelado</strong></td>
                  <td scope="row">
                    ${oldValues != null && oldValues.SpreadConfigurations != null ? this.bindSpreadConfigurationsAuditingInfo(oldValues.SpreadConfigurations) : ""}
                  </td>
                  <td scope="row">
                    ${newValues != null && newValues.SpreadConfigurations != null ? this.bindSpreadConfigurationsAuditingInfo(newValues.SpreadConfigurations) : ""}
                  </td>
                </tr>
                `;
      return content;
    },
    bindSpreadConfigurationsAuditingInfo(spreadConfigurations) {
      let content = '';
      let formatter = new Intl.NumberFormat('pt-BR');
      for (let index = 0; index < spreadConfigurations.length; index++) {
        const element = spreadConfigurations[index];
        content += `
        <strong>Parcela</strong>: ${element.QtyParcels}
        <br />
        <strong>Taxa %</strong>: ${formatter.format(element.PartnerFee)}
        <br />
        <strong>Plataforma %</strong>: ${formatter.format(element.PlatformFee)}
        <br />
        <strong>Comissão %</strong>: ${formatter.format(element.SalesManFee)}
        <br />
        <strong>Dias Disponivel</strong>: ${formatter.format(element.PayoutIntervalId)}
        <hr />
        `;
      }
      return content;
    }
  }
};
</script>
<style scoped>
.action-btn {
  width: 38px !important;
}
</style>
